import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/auth";
import { Link } from "react-router-dom";

// import NotFound from "../404";
import useHttp from "../../hooks/use-http";
import { endPoints } from "../../config/end-points";

const Tutorials = () => {
  const [tutorials, setTutorials] = useState([]);
  const dispatch = useDispatch();
  //   const access = useSelector((state) => state.auth.access);
  const { sendRequest } = useHttp();

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });

  const meta_data = useSelector(state => state.auth.product.meta_data)
  const logo = meta_data && JSON.parse(meta_data).subdomainLogo ? JSON.parse(meta_data).subdomainLogo : `${process.env.PUBLIC_URL}/newlogo.png`;


  useEffect(() => {
    sendRequest(
      {
        url: endPoints.tutorials,
        method: "GET",
      },
      (response) => {
        if (response && response.length >= 1) {
          setTutorials(response);
        }
      }
    );
  }, [sendRequest]);


  return (
    <section className="mid_wrap">
      <div className="container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-4 pb-2">
            <li className="breadcrumb-item">
              <Link to="/">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Tutorials
            </li>
          </ol>
        </nav>
        <div className="row">
          {tutorials &&
            tutorials.length > 1 &&
            tutorials.map((ele) => {
              return (
                <div className="col-md-8 m-auto mb-4" key={ele.name}>
                  <div className="card">
                    <div className="card-header text-center">
                      {/* <h5 className="car-title text-center"> */}
                        <b>{ele.name}</b>
                      {/* </h5> */}
                    </div>
                    {(ele.url && ele.url.length > 0) && (
                      <div className="card-block">
                        <div className="embed-responsive embed-responsive-16by9">
                          <iframe
                            title={ele.name}
                            src={ele.url}
                            width="100%"
                            height="360"
                            className="embed-responsive-item"
                            allowFullScreen={true}
                            // webkitallowfullscreen={true}
                            // mozallowfullscreen={true}
                          ></iframe>
                        </div>
                      </div>
                    )}
                    {(ele.link && ele.link.length > 0) && (
                      <div className="card-footer text-center p-5">
                        {(ele.url && ele.url.length > 0) && (
                          <p className="text-center mb-4">OR</p>
                        )}
                        <a className="btn btn-info py-2" target="_blank" rel="noreferrer" href={ele.link}>Click Here to access knowledgebase</a>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}

          {tutorials.length === 0 && (
            <div className="col-md-12 mb-4">
              <div className="bx_a">
                <div className="emptyDiv">
                  <img
                    src={logo}
                    alt="img"
                    className="mt-4 mb-4"
                  />

                  <h2>Comming Soon..</h2>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Tutorials;
